<span *ngIf="data.clicked == 1">
    <div *ngIf="!isSmallScreen" class="user-popup-container">
        <div class="user-popup-content">
            <div class="user-popup-header">
                <svg (click)="closed()" class="close-icon" viewBox="0 0 30 30" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g id="Close">
                        <path d="M21.5625 8.4375L8.4375 21.5625" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M8.4375 8.4375L21.5625 21.5625" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                </svg>
            </div>
            <form #addZoneDetails="ngForm" (ngSubmit)="addSite()">
                <div class="input-container">
                    <div class="container-left">
                        <div class="form-group">
                            <span class="label-container">
                                <span>
                            <label for="addsitename">Site name&nbsp;<span style="color: #ba0001">*</span></label>
                            </span>
                            <span>
                                <div *ngIf="addzonenameInput.invalid && addzonenameInput.touched" class="vehicle-error-message">
                                <span *ngIf="addzonenameInput.errors?.['required']">Site name is required</span>
                                </div>
                            </span>
                            </span>
                            <input id="addsitename" name="addsitename" [(ngModel)]="addsitename" required
                                #addzonenameInput="ngModel" type="text" placeholder="Site name" />
                        </div>
                        <div class="form-group">
                            <span class="label-container">
                                <span>
                                    <label for="addtype">Type</label>&nbsp;<span style="color: #ba0001">*</span>
                                </span>
                                <span>
                                    <div *ngIf="typeInput.invalid && typeInput.touched" class="vehicle-error-message">
                                        <span *ngIf="typeInput.errors?.['required']">Type is required</span>
                                    </div>
                                </span>
                            </span>
                            <select class="dropdown" id="addtype" required #typeInput="ngModel" [(ngModel)]="selectedType" name="type">
                                <option [ngValue]="null" disabled style="color: #acabac">Select type</option>
                                <option *ngFor="let type of typeOptions" [ngValue]="type.value">{{ type.label }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <span class="label-container">
                                <span>
                                    <label for="addstatus">Status</label>&nbsp;<span style="color: #ba0001">*</span>
                                </span>
                                <span>
                                    <div *ngIf="statusInput.invalid && statusInput.touched" class="vehicle-error-message">
                                    <span *ngIf="statusInput.errors?.['required']">Status is required</span>
                                    </div>
                                </span>
                            </span>
                            <select class="dropdown" id="addstatus" required #statusInput="ngModel" [(ngModel)]="selectedStatus" name="status">
                                <option [ngValue]="null" disabled style="color: #acabac">Select status</option>
                                <option *ngFor="let status of statusoption" [ngValue]="status.value">{{ status.label }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <span class="label-container">
                                <span>
                            <label for="addaddress">Address&nbsp;<span style="color: #ba0001">*</span></label>
                            </span>
                            <span>
                            <div *ngIf="addAddress.invalid && addAddress.touched" class="vehicle-error-message">
                            <span *ngIf="addAddress.errors?.['required']">Address is required</span>
                            </div>
                            </span>
                            </span>
                            <input id="addaddress" name="address" [(ngModel)]="address" required #addAddress="ngModel"
                                type="text" placeholder="Address" />
                        </div>
                        <div class="form-group">
                            <label for="company">Company</label>
                            <input placeholder="Company" type="text" name="company" id="company" #addCompany="ngModel"
                                [(ngModel)]="company" />
                        </div>
                        <div class="form-group">
                            <label for="description">Description</label>
                            <input id="description" name="description" [(ngModel)]="description"
                                #addDescInput="ngModel" type="text" placeholder="Description" />
                        </div>
                        <div class="form-group">
                            <span class="label-container">
                                <span>
                            <label for="enrollmentDate">Enrollment Date&nbsp;<span
                                    style="color: #ba0001">*</span></label>
                                    </span>
                                    <span>
                                    <div *ngIf="enrollmentDateInput.invalid && enrollmentDateInput.touched" class="vehicle-error-message">
                                    <span *ngIf="enrollmentDateInput.errors?.['required']">Enrollment date is required</span>
                                    </div>
                                    </span>
                                    </span>
                            <input id="enrollmentDate" name="enrollmentDate" [(ngModel)]="enrollmentDate" required
                                #enrollmentDateInput="ngModel" type="date" [max]="today"/>
                        </div>
                    </div>
                </div>
            <button class="save-button" type="submit"
                [disabled]="addZoneDetails.invalid || isLoadingfirst">
                <span *ngIf="!isLoadingfirst">Save</span>
                <div *ngIf="isLoadingfirst" class="loader-container">
                    <div class="loader"></div>
                </div>
            </button>
            </form>
        </div>
    </div>
</span>
<span *ngIf="data.clicked == 2">
    <div *ngIf="!isSmallScreen" class="user-popup-container">
        <div class="user-popup-content">
            <div class="user-popup-header">
                <svg (click)="closed()" class="close-icon" viewBox="0 0 30 30" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g id="Close">
                        <path d="M21.5625 8.4375L8.4375 21.5625" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M8.4375 8.4375L21.5625 21.5625" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                </svg>
            </div>
            <form #editZoneDetails="ngForm" (ngSubmit)="editSite()">
                <div class="input-container">
                    <div class="container-left">
                        <div class="form-group">
                            <span class="label-container">
                                <span>
                                <label for="editSiteName">Site name&nbsp;<span style="color: #ba0001">*</span></label>
                                </span>
                                <span>
                                <div *ngIf="editZoneNameInput.invalid && editZoneNameInput.touched" class="vehicle-error-message">
                                <span *ngIf="editZoneNameInput.errors?.['required']">Site name is required</span>
                                </div>
                                </span>
                            </span>
                            <input id="editSiteName" name="editSiteName" [(ngModel)]="editSiteName" required
                                #editZoneNameInput="ngModel" type="text" placeholder="Site name" />
                        </div>
                        <div class="form-group">
                            <span class="label-container">
                                <span>
                                    <label for="editType">Type</label>&nbsp;<span style="color: #ba0001">*</span>
                                </span>
                                <span>
                                    <div *ngIf="editTypeInput.invalid && editTypeInput.touched" class="vehicle-error-message">
                                        <span *ngIf="editTypeInput.errors?.['required']">Type is required</span>
                                    </div>
                                </span>
                            </span>
                            <select class="dropdown" id="editType" [(ngModel)]="selectedType" name="type" required
                                #editTypeInput="ngModel">
                                <option *ngFor="let type of typeOptions" [ngValue]="type.value">
                                    {{ type.label }}
                                </option>
                            </select>
                        </div>
                             <div *ngIf="permission[4].siteManagement?.status" class="form-group">
                                <span class="label-container">
                                    <span>
                                        <label for="status">Status</label>&nbsp;<span style="color: #ba0001">*</span>
                                        </span>
                                        <span>
                                            <div *ngIf="editStatusInput.invalid && editStatusInput.touched" class="vehicle-error-message">
                                            <span *ngIf="editStatusInput.errors?.['required']">Status is required</span>
                                            </div>
                                            </span>
                                        </span>
                                        <select class="dropdown" id="status" [(ngModel)]="selectedStatus" name="status" required
                                            #editStatusInput="ngModel">
                                            <option *ngFor="let status of statusoption" [ngValue]="status.value">
                                            {{ status.label }}
                                            </option>
                                        </select>
                                        </div>
                        <div class="form-group">
                            <span class="label-container">
                                <span>
                            <label for="editAddress">Address&nbsp;<span style="color: #ba0001">*</span></label>
                            </span>
                            <span>
                            <div *ngIf="addressModel.invalid && addressModel.touched" class="vehicle-error-message">
                            <span *ngIf="addressModel.errors?.['required']">Address is required</span>
                            </div>
                            </span>
                            </span>
                            <input id="editAddress" name="editAddress" [(ngModel)]="editAddress" required
                                #addressModel="ngModel" placeholder="Address" type="text" />
                        </div>
                        <div class="form-group">
                            <label for="editCompany">Company</label>
                            <input id="editCompany" name="editCompany" [(ngModel)]="editCompany"
                                #editComapny="ngModel" type="text" placeholder="Company" />
                        </div>
                        <div class="form-group">
                            <label for="editDescription">Description</label>
                            <input id="editDescription" name="editDescription" [(ngModel)]="editDescription"
                                #editDescInput="ngModel" type="text" placeholder="Description" />
                        </div>
                        <div class="form-group">
                            <span class="label-container">
                                <span>
                            <label for="editEnrollmentDate">Enrollment Date&nbsp;<span
                                    style="color: #ba0001">*</span></label>
                                    </span>
                                    <span>
                                    <div *ngIf="editEnrollmentDateInput.invalid && editEnrollmentDateInput.touched" class="vehicle-error-message">
                                    <span *ngIf="editEnrollmentDateInput.errors?.['required']">Enrollment date is required</span>
                                    </div>
                                    </span>
                                    </span>
                            <input style="width: 100%;" id="editEnrollmentDate" name="editEnrollmentDate"
                                [(ngModel)]="formattedDate" required #editEnrollmentDateInput="ngModel" type="date" [max]="today"/>
                        </div>
                    </div>
                </div>
                <button class="save-button" type="submit"
                [disabled]="editZoneDetails.invalid || isLoadingfirst">
                <span *ngIf="!isLoadingfirst">Save</span>
                <div *ngIf="isLoadingfirst" class="loader-container">
                    <div class="loader"></div>
                </div>
            </button>
            </form>
        </div>
    </div>
</span>
<span *ngIf="data.clicked == 3">
    <div class="signout-popup-container">
        <div class="signout-popup-header">
            <svg [ngStyle]="{
                height: isSmallScreen ? '24' : '30'
              }" (click)="closed()" class="close-icon" viewBox="0 0 30 30" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g id="Close">
                    <path id="Vector" d="M21.5625 8.4375L8.4375 21.5625" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path id="Vector_2" d="M8.4375 8.4375L21.5625 21.5625" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                </g>
            </svg>
        </div>
        <div class="signout-popup-content">
            <div class="main-txt">Are you sure you want to delete?</div>
            <button class="sign-out-btn" (click)="DeleteSite()">
                <span *ngIf="!isLoadingfirst">Delete</span>
                <div *ngIf="isLoadingfirst" class="loader-container">
                    <div class="loader"></div>
                </div>
            </button>
        </div>
    </div>
</span>